import React, { useState, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useParams, generatePath } from 'react-router';
import axios from 'axios';
// import VConsole from 'vconsole';
import QRCodeScanner from './QRCodeScanner';
import Calculator from './Calculator';
import PointDetail from './PointDetail';
import constClass from '../../Constants/Constants';
import UseAlertModal from '../Common/UseAlertModal';

const initialAppState = {
  site_id: null,
  customer_id: null,

  qrcode_err: null,
  membership_id: null,  //会員ID
  customer_name: '',    //お客様名
  available_point: 0,   //利用可能ポイント
  customer_rank: null,    //会員ランク

  inputValue: 0,      //対象金額
  pointUseFlag: null,       //ポイント利用(つかう:true,ためる:false)
  use_point: 0,   //クーポン利用のポイント

  couponUseFlag: null,
  usePoint: 0,        //利用ポイント
  paymentValue: 0,    //支払金額
  addPoint: 0,        //加算ポイント
  pointBalance: 0,    //ポイント残高

  paymentMethod: constClass.PAYMENT_METHOD.CASH,
  campaignMagnification: null,   //キャンペーン倍率
  campaignName: "",
  addBonusPoint: 0,

  pointCampaignList: null, //現在開催中のキャンペーン一覧
  ticketList: null, //付与されるチケット一覧

  pointRegist: false,//ポイント付与確定

  mall_id: null,
  shop_id: null,
  cashier_no: null,
  user_id: null,

  point_datetime: null, //会員証を読み取った時点の日時(対象キャンペーン表示/算出日時)
  isNow: true, //ポイント
};

var processFlag = false;

const QRApp = (props) => {
  const { user, setting } = props;
  const { cardId } = useParams();
  const [message, setMessage] = useState('');
  const [scanning, setScanning] = useState(true);
  const [mode, setMode] = useState(constClass.POINT_SCREEN.CAMERA);
  const [appState, setAppState] = useState({ ...initialAppState, site_id: user.siteId, mall_id: user.mallId, shop_id: user.shopId, cashier_no: user.cashierNo, user_id: user.userId });
  const [isAlertModalOpen, setIsAlertModalOpen] = useState(false);
  const [alertModalMessage, setAlertModalMessage] = useState('');
  const history = useHistory();
  const [ticketGroupMessage, setTicketGroupMessage] = useState('');
  const [pointUuid, setPointUuid] = useState(null);

  // if (process.env.REACT_APP_ENV !== 'pro') {
  //   new VConsole();
  // }

  const closeAlertModal = () => {
    setIsAlertModalOpen(false);
  };

  const setQrCodeData = useCallback(async (qrData) => {
    if (qrData || cardId || appState.membership_id !== null) {
      // var winRef;
      setScanning(false);

      const jwt = localStorage.getItem('jwt');
      const siteId = props.match.params.siteId;
      const sysdate = new Date();

      try {
        //施設情報を取得
        const mall = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/mall/${siteId}/${user.mallId}`, { site_id: siteId }, {
          headers: {
            Authorization: `Bearer ${jwt}`,
          }
        })).data;
        //会員情報を取得
        var customer_data = null;
        if (cardId || appState.membership_id) {
          customer_data = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/customer/card/${siteId}`, { card_id: cardId ? cardId : appState.membership_id }, {
            headers: {
              Authorization: `Bearer ${jwt}`,
            }
          })).data;
        } else {
          customer_data = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/customer/card/${siteId}`, { qr_data: qrData }, {
            headers: {
              Authorization: `Bearer ${jwt}`,
            }
          })).data;
        }
        if (!customer_data || customer_data.data.status !== constClass.STATUS.REG) {
          throw new Error("有効な会員情報が取得できませんでした")
        }
        const customerId = customer_data.data.customer_id;
        var ticketIdData;
        //誰でも使えるクーポンまたは特定の人専用のクーポンまたは、特定の人専用のクーポン
        if (customer_data.issue_count && customer_data.benefit_id) {
          setTicketGroupMessage("");
          ticketIdData = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/benefitgrant/${siteId}/${customer_data.benefit_id}/${customerId}/${customer_data.issue_count}`, {
            headers: {
              Authorization: `Bearer ${jwt}`
            }
          })).data;

          if (ticketIdData.mall_id !== Number(user.mallId)) {
            setTicketGroupMessage("別施設のアプリクーポンは利用できません");
          }

          if (ticketIdData.shop_group.length > 0) {
            const shopGroup = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/shopgroup/${siteId}/${user.mallId}/${user.shopId}`, {
              headers: {
                Authorization: `Bearer ${jwt}`,
              }
            })).data;

            //ログインしている店舗がどこかのショップグループに属している場合
            const isShopInGroupOn = ticketIdData.shop_group.some(ticketGroup => {
              if (ticketGroup.use_flg === constClass.FLAG.OFF) {
                return shopGroup.some(shop => {
                  return shop.shop_group_id === ticketGroup.shop_group_id;
                });
              }
              return false;
            });
            const isShopInGroupOff = ticketIdData.shop_group.some(ticketGroup => {
              if (ticketGroup.use_flg === constClass.FLAG.ON) {
                return shopGroup.some(shop => {
                  return shop.shop_group_id === ticketGroup.shop_group_id;
                });
              }
              return true;
            });
            if (isShopInGroupOn) {
              setTicketGroupMessage("このクーポンの利用不可な店舗に、貴店が含まれているため、使用できません");
            } else if (!isShopInGroupOff) {
              setTicketGroupMessage("このクーポンの利用可能な店舗に、貴店は含まれていないため、使用できません");
            }
          }
        }
        else if (customer_data.ticket_id && customer_data.issue_count) {
          setTicketGroupMessage("");
          ticketIdData = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/ticket_issue/${siteId}/${customer_data.ticket_id}/${customerId}/${customer_data.issue_count}`, {
            headers: {
              Authorization: `Bearer ${jwt}`
            }
          })).data;

          if (ticketIdData.mall_id !== Number(user.mallId)) {
            setTicketGroupMessage("別施設のアプリクーポンは利用できません");
          }

          if (ticketIdData.shop_group.length > 0) {
            const shopGroup = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/shopgroup/${siteId}/${user.mallId}/${user.shopId}`, {
              headers: {
                Authorization: `Bearer ${jwt}`,
              }
            })).data;

            //ログインしている店舗がどこかのショップグループに属している場合
            const isShopInGroupOn = ticketIdData.shop_group.some(ticketGroup => {
              if (ticketGroup.use_flg === constClass.FLAG.OFF) {
                return shopGroup.some(shop => {
                  return shop.shop_group_id === ticketGroup.shop_group_id;
                });
              }
              return false;
            });
            const isShopInGroupOff = ticketIdData.shop_group.some(ticketGroup => {
              if (ticketGroup.use_flg === constClass.FLAG.ON) {
                return shopGroup.some(shop => {
                  return shop.shop_group_id === ticketGroup.shop_group_id;
                });
              }
              return true;
            });
            if (isShopInGroupOn) {
              setTicketGroupMessage("このクーポンの利用不可な店舗に、貴店が含まれているため、使用できません");
            } else if (!isShopInGroupOff) {
              setTicketGroupMessage("このクーポンの利用可能な店舗に、貴店は含まれていないため、使用できません");
            }
          }
          if (ticketIdData.ticket_group.length > 0) {
            const ticket_group = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/ticketgroup/${siteId}/list/`, { mall_id: user.mallId }, {
              headers: {
                Authorization: `Bearer ${jwt}`,
              }
            })).data;

            const ticket_count = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/ticket/${siteId}/${user.mallId}/countlist/`, {
              headers: {
                Authorization: `Bearer ${jwt}`,
              }
            })).data;

            const ticket_issuecount = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/ticket_issue/${siteId}/${user.mallId}/issuecountlist/`, {
              headers: {
                Authorization: `Bearer ${jwt}`,
              }
            })).data;

            const merged_count = [...ticket_count, ...ticket_issuecount].reduce((acc, item) => {
              if (!acc[item.ticket_id]) {
                acc[item.ticket_id] = { ticket_id: item.ticket_id, count: 0 };
              }
              acc[item.ticket_id].count += Number(item.count) || 0;
              return acc;
            }, {});

            const over_ticket = [];
            ticket_group.forEach(group => {
              if (group.m_ticket_group_ticket) {
                const groupTotalCount = group.m_ticket_group_ticket.reduce((sum, t) => {
                  const ticketId = t.ticket_id;
                  return sum + (merged_count[ticketId]?.count || 0);
                }, 0);

                if (group.max_usage_count !== null && group.max_usage_count !== undefined && groupTotalCount >= group.max_usage_count) {
                  group.m_ticket_group_ticket.forEach(t => {
                    over_ticket.push(t.ticket_id);
                  });
                }
              }
            });
            if (over_ticket.length > 0 && over_ticket.includes(ticketIdData.ticket_id)) {
              setTicketGroupMessage("利用可能回数を超えているため、使用できません");
            }
          }
        } else if (customer_data.ticket_id) {
          setTicketGroupMessage("");  
          ticketIdData = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/ticket/${siteId}/${customer_data.ticket_id}/${customerId}`, {
            headers: {
              Authorization: `Bearer ${jwt}`
            }
          })).data;

          if (ticketIdData.mall_id !== Number(user.mallId)) {
            setTicketGroupMessage("別施設のアプリクーポンは利用できません");
          }          
          
          //読み込んだクーポンが利用可、不可を設定している場合
          if (ticketIdData.shop_group.length > 0) {
            const shopGroup = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/shopgroup/${siteId}/${user.mallId}/${user.shopId}`, {
              headers: {
                Authorization: `Bearer ${jwt}`,
              }
            })).data;
            //ログインしている店舗がどこかのショップグループに属している場合
            const isShopInGroupOn = ticketIdData.shop_group.some(ticketGroup => {
              if (ticketGroup.use_flg === constClass.FLAG.OFF) {
                return shopGroup.some(shop => {
                  return shop.shop_group_id === ticketGroup.shop_group_id;
                });
              }
              return false;
            });
            const isShopInGroupOff = ticketIdData.shop_group.some(ticketGroup => {
              if (ticketGroup.use_flg === constClass.FLAG.ON) {
                return shopGroup.some(shop => {
                  return shop.shop_group_id === ticketGroup.shop_group_id;
                });
              }
              return true;
            });
            if (isShopInGroupOn) {
              setTicketGroupMessage("このクーポンの利用不可な店舗に、貴店が含まれているため、使用できません");
            } else if (!isShopInGroupOff) {
              setTicketGroupMessage("このクーポンの利用可能な店舗に、貴店は含まれていないため、使用できません");
            }
          }
          if (ticketIdData.ticket_group.length > 0) {
            const ticket_group = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/ticketgroup/${siteId}/list/`, { mall_id: user.mallId }, {
              headers: {
                Authorization: `Bearer ${jwt}`,
              }
            })).data;

            const ticket_count = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/ticket/${siteId}/${user.mallId}/countlist/`, {
              headers: {
                Authorization: `Bearer ${jwt}`,
              }
            })).data;

            const ticket_issuecount = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/ticket_issue/${siteId}/${user.mallId}/issuecountlist/`, {
              headers: {
                Authorization: `Bearer ${jwt}`,
              }
            })).data;

            const merged_count = [...ticket_count, ...ticket_issuecount].reduce((acc, item) => {
              if (!acc[item.ticket_id]) {
                acc[item.ticket_id] = { ticket_id: item.ticket_id, count: 0 };
              }
              acc[item.ticket_id].count += Number(item.count) || 0;
              return acc;
            }, {});

            const over_ticket = [];
            ticket_group.forEach(group => {
              if (group.m_ticket_group_ticket) {
                const groupTotalCount = group.m_ticket_group_ticket.reduce((sum, t) => {
                  const ticketId = t.ticket_id;
                  return sum + (merged_count[ticketId]?.count || 0);
                }, 0);

                if (group.max_usage_count !== null && group.max_usage_count !== undefined && groupTotalCount >= group.max_usage_count) {
                  group.m_ticket_group_ticket.forEach(t => {
                    over_ticket.push(t.ticket_id);
                  });
                }
              }
            });

            if (over_ticket.length > 0 && over_ticket.includes(ticketIdData.ticket_id)) {
              setTicketGroupMessage("利用可能回数を超えているため、使用できません");
            }
          }
        }
        //有効ポイントの合計を取得
        var available_point = customer_data.data.point;
        //ランクマスタ情報を取得
        const rank_info = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/mastercustomerrank/ranklist/`, { site_id: siteId }, {
          headers: {
            Authorization: `Bearer ${jwt}`,
          }
        })).data;

        //現在のユーザのランクを取得
        const rank_customer_info = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/customerrank/backyard/search/`, { site_id: siteId, customer_id: customerId }, {
          headers: {
            Authorization: `Bearer ${jwt}`,
          }
        })).data;
        //ランク情報がない場合、最初のランクに設定
        const user_rank = rank_customer_info ? rank_customer_info.rank_id : rank_info[0].rank_id;

        //対象のキャンペーン情報を取得
        const resPointCampaign = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/point_campaign/list/`, { site_id: siteId, mall_id: user.mallId, shop_id: user.shopId, datetime: null }, {
          headers: {
            Authorization: `Bearer ${jwt}`,
          }
        })).data;

        const currentDay = sysdate.getDay(); // 0: 日曜日, 1: 月曜日, ..., 6: 土曜日
        const currentHour = sysdate.getHours();
        const day = parseInt(String(sysdate.getDate()).padStart(2, '0'), 10);
        let isDayValid = null;

        // ポイントキャンペーンをフィルタリング
        const point_campaign = resPointCampaign.filter(campaign => {
          if (campaign.m_schedule) {
            // 開始時間、終了時間を確認
            const startTime = campaign.m_schedule.start_time;
            const endTime = campaign.m_schedule.end_time;
            const isTimeValid = currentHour >= startTime && currentHour <= endTime;
            console.log(campaign.m_schedule.schedule_type);
            // スケジュール区分：0(曜日)の場合、当日の曜日、時間帯が適切かどうかでフィルタリング
            if (campaign.m_schedule.schedule_type === "0") {
              const weekdays = campaign.m_schedule.weekdays;
              const isWeekdayValid = weekdays.includes(currentDay);
              return isWeekdayValid && isTimeValid;
            // スケジュール区分：1(日付)の場合、当日の日付、時間帯が適切かどうかでフィルタリング
            } else if (campaign.m_schedule.schedule_type === "1") {
              const startDate = parseInt(campaign.m_schedule.start_date, 10);
              const endDate = parseInt(campaign.m_schedule.end_date, 10);
              if (startDate <= endDate) {
                isDayValid = day >= startDate && day <= endDate;
                return isDayValid && isTimeValid;
              } else {
                isDayValid = day <= endDate || day >= startDate;
                return isDayValid && isTimeValid;
              }
            } else {
              return false;
            }
          // スケジュールを設定していない場合は無条件でフィルタリング対象
          } else {
            return true;
          }
        }).filter(pointCampaign => 
          pointCampaign.point_campaign_ranks.length === 0 || 
          pointCampaign.point_campaign_ranks.some(rank => rank.rank_id === user_rank)
        );

        setAppState({
          ...appState,
          site_id: siteId,
          mall_id: user.mallId,
          shop_id: user.shopId,
          cashier_no: user.cashierNo,
          customer_id: customerId,
          qrcode_err: null,
          membership_id: customer_data.data.card_id,
          customer_name: customer_data.data.customer_name,
          available_point,
          use_point: customer_data.benefit_id ? 0 : ticketIdData ? ticketIdData.use_point : appState.selectData ? appState.selectData.use_point : 0,
          couponUseFlag: ticketIdData ? true : null,
          selectData: ticketIdData ? ticketIdData : null,
          customer_rank: user_rank >= 1 ? rank_info[user_rank - 1] : null,
          pointCampaignList: point_campaign,
          point_rate: setting && setting['DEFAULT_POINT_RATE'] ? setting['DEFAULT_POINT_RATE'] : 0,
          point_base_amount: setting && setting['DEFAULT_POINT_BASE_AMOUNT'] ? setting['DEFAULT_POINT_BASE_AMOUNT'] : 0,
          max_point: mall ? Number(mall.point_limit) : 'MAX_POINT' in setting.values[siteId] ? Number(setting['MAX_POINT']) : 0,
          paymentMethod: Number(user.mallId) !== 1 ? constClass.PAYMENT_METHOD.CARD : constClass.PAYMENT_METHOD.CASH,
          point_datetime: sysdate ? sysdate : null,       
        });
        // const intervalId = window.setInterval(() => {
        //   window.clearInterval(intervalId);
        //   window.close();
        // }, 5000);
      } catch (err) {
        setAppState({
          ...appState,
          site_id: siteId,
          mall_id: user.mallId,
          shop_id: user.shopId,
          cashier_no: user.cashierNo,
          customer_id: null,
          qrcode_err: (err.response && err.response.data) ? err.response.data.msg : err.response ? err.response : err.message ? err.message : null,
          membership_id: null,
          customer_name: '',
          available_point: 0,
          use_point: 0,
          couponUseFlag: null,
          selectData: null,
          customer_rank: null,
          pointCampaignList: null,
          point_rate: null,
          point_base_amount: null,
          max_point: 0,
          paymentMethod: Number(user.mallId) !== 1 ? constClass.PAYMENT_METHOD.CARD : constClass.PAYMENT_METHOD.CASH,
          sysdate: null,
        })
      }

      setMode(constClass.POINT_SCREEN.MAIN);
      setScanning(true);

    } else {
      setMessage('読み取りに失敗しました。再度読み取りをお願いします。');
    }
  }, [appState, props.match.params.siteId, user, setting, cardId]);

  const setPointRegist = useCallback(async () => {
    const siteId = props.match.params.siteId;
    if (processFlag) {
      return;
    };
    processFlag = true;
    const params = { ...appState };
    params.point_uuid = pointUuid;
    try {
      const jwt = localStorage.getItem('jwt');
      const res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/points/${siteId}`, params, {
        headers: {
          Authorization: `Bearer ${jwt}`,
        }
      });
      if (res && res.data.error) {
        setAlertModalMessage(res.data.message)
        setIsAlertModalOpen(true);
      }
      else {
        if (res && res.data && Array.isArray(res.data.data)) {
          var data = res.data.data;
          const totalPoint = data.reduce((sum, item) => sum + (item.point || 0), 0);
          const campaignList = data.flatMap(item => item.campaignlist || []);
          setAppState({
            ...appState,
            pointRegist: true,
            addPoint: totalPoint,
            pointCampaignList: campaignList,
            ticketList: res.data.ticket ? res.data.ticket : [],
          });
        } else {
          setAppState({ ...initialAppState, site_id: user.siteId, mall_id: user.mallId, shop_id: user.shopId, cashier_no: user.cashierNo, user_id: user.userId });
          setMode(constClass.POINT_SCREEN.CAMERA);
        }
      }
    } catch (err) {
      if (err.response.data !== null) {
        setAlertModalMessage(err.response.data.message)
        setIsAlertModalOpen(true);
      } else {
        setAlertModalMessage(err.response)
        setIsAlertModalOpen(true);
      }
    } finally {
      processFlag = false;
    }

  }, [appState, props.match.params.siteId, user, pointUuid]);

  const setRegistClose = useCallback(async () => {
    setAppState({ ...initialAppState, site_id: user.siteId, mall_id: user.mallId, shop_id: user.shopId, cashier_no: user.cashierNo, user_id: user.userId });
    setMode(constClass.POINT_SCREEN.CAMERA);
    history.push(`${generatePath(`${props.match.path}`, { siteId: props.match.params.siteId, mallId: props.match.params.mallId })}pointterminal/`);
  }, [user, history, props.match.path, props.match.params.siteId, props.match.params.mallId]);

  const gotoPointHistory = (customer_id) => {
    history.push(`${generatePath(`${props.match.path}`, { siteId: props.match.params.siteId, mallId: props.match.params.mallId })}pointhistory/${customer_id}`)
  }
  const resetCamera = () => {
    history.push(`${generatePath(`${props.match.path}`, { siteId: props.match.params.siteId, mallId: props.match.params.mallId })}pointterminal/`)
  }
  return (
    <div className="container-fluid">
      <UseAlertModal isOpen={isAlertModalOpen} message={alertModalMessage} onClose={closeAlertModal} />
      {mode === constClass.POINT_SCREEN.MAIN && <Calculator setMode={setMode} appState={appState} setAppState={setAppState} setQrCodeData={setQrCodeData} siteId={props.match.params.siteId} gotoPointHistory={gotoPointHistory} resetCamera={resetCamera} ticketGroupMessage={ticketGroupMessage} setPointUuid={setPointUuid} />}
      {mode === constClass.POINT_SCREEN.CAMERA &&
        <React.Fragment>
          <div className="vertical">
            <div className="row">
              <div className="col text-center">
                <span>会員証・クーポン読み取り</span>
              </div>
            </div>
            <QRCodeScanner {...props} setMode={setMode} setQrCodeData={setQrCodeData} message={message} appState={appState} scanning={scanning} cardId={cardId} />
            <div className="row">
              <div className="col text-center mt-2">
                <span>QRコードをスキャンしてください</span>
              </div>
            </div>
            <div className="row">
              <div className="col text-center mt-2">
                <span>カメラが表示されない場合は、画面を更新してください</span>
              </div>
            </div>
          </div>
        </React.Fragment>
      }
      {mode === constClass.POINT_SCREEN.DETAIL && <PointDetail {...props} setMode={setMode} appState={appState} setPointRegist={setPointRegist} setRegistClose={setRegistClose} />}
    </div>
  );
}

export default QRApp;